import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';
import clsx from 'clsx';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Services', href: isHomePage ? '#services' : '/#services' },
    { name: 'Work', href: isHomePage ? '#work' : '/#work' },
    { name: 'Testimonials', href: isHomePage ? '#testimonials' : '/#testimonials' },
    { name: 'Contact', href: isHomePage ? '#contact' : '/#contact' },
  ];

  return (
    <>
      {/* Top Bar with Phone CTA */}
      <div className="bg-cyan-500 text-black py-2 text-center text-sm font-semibold">
        <a href={`tel:${companyInfo.phone}`} className="flex items-center justify-center gap-2 hover:underline">
          <Phone size={14} />
          <span>Call {companyInfo.phone} - Get 20% OFF Your First Service!</span>
        </a>
      </div>

      <header
        className={clsx(
          'fixed top-8 left-0 right-0 z-50 transition-all duration-300',
          isScrolled ? 'bg-black/95 backdrop-blur-sm py-2' : 'bg-black/80 backdrop-blur-sm py-3'
        )}
      >
        <div className="container mx-auto px-4 lg:px-8">
          <nav className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3">
              <img
                src={companyInfo.logoDark}
                alt={companyInfo.name}
                className="h-12 md:h-16 lg:h-20 w-auto object-contain"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="nav-link text-white/80 hover:text-cyan-400 transition-colors font-normal"
                >
                  {link.name}
                </a>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="hidden lg:flex items-center gap-4">
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors"
              >
                <Phone size={18} />
                <span className="font-mono text-sm tracking-wider">{companyInfo.phone}</span>
              </a>
              <a
                href={isHomePage ? '#contact' : '/#contact'}
                className="cta-button bg-cyan-500 text-black border-cyan-500 hover:bg-cyan-400 hover:border-cyan-400"
              >
                Free Consultation
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-white p-2"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </nav>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-sm border-t border-white/10">
              <div className="flex flex-col p-6 gap-4">
                {navLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.href}
                    className="text-white/80 hover:text-cyan-400 transition-colors py-2 text-lg"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {link.name}
                  </a>
                ))}
                <div className="border-t border-white/10 pt-4 mt-2">
                  <a
                    href={`tel:${companyInfo.phone}`}
                    className="flex items-center gap-2 text-cyan-400 py-2 font-semibold"
                  >
                    <Phone size={18} />
                    <span>{companyInfo.phone}</span>
                  </a>
                  <p className="text-yellow-400 text-sm mt-1">Get 20% OFF when you call!</p>
                </div>
                <a
                  href={isHomePage ? '#contact' : '/#contact'}
                  className="cta-button bg-cyan-500 text-black text-center mt-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Schedule Free Consultation
                </a>
              </div>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
